import { useSelector } from "react-redux";
import { getCriteriaVisibility } from "../input/selectors";

export default function useCriteriaVisibility(criteria) {
	return useSelector((state) => getCriteriaVisibility(state, criteria));
}
